import { Link } from "react-router-dom";

export default function Logo({
  variant = "default",
  className = "",
  onClick,
  showText = true,
  to = "/",
}) {
  const logoImg = (
    <picture>
      <source
        srcSet="/images/logo/TrishulLogo_72.webp 1x, /images/logo/TrishulLogo_144.webp 2x"
        type="image/webp"
      />
      <img
        className="brand-mark"
        src="/images/logo/TrishulLogo_72.webp"
        alt="Trishul Tours &amp; Travels logo"
        width="72"
        height="72"
        decoding="async"
        fetchpriority="high"
      />
    </picture>
  );

  if (variant === "footer") {
    return (
      <Link to={to} className={`foot-brand-logo-wrap ${className}`} onClick={onClick}>
        <div className="foot-brand-logo">{logoImg}</div>
        {showText && (
          <div className="footer-brand-name" aria-label="Trishul Tours and Travels">
            {/* <div className="t1">TRISHUL</div>
            <div className="t2">Tours &amp; Travels</div> */}
          </div>
        )}
      </Link>
    );
  }

  if (variant === "auth") {
    return (
      <Link to={to} className={`auth-brand-logo ${className}`} onClick={onClick}>
        {logoImg}
      </Link>
    );
  }

  if (variant === "admin") {
    return (
      <Link className={`admin-brand ${className}`} to={to} onClick={onClick}>
        {logoImg}
        {showText && (
          <span className="brand-text">
            <span className="t1">TRISHUL</span>
            <span className="t2">Tours &amp; Travels</span>
          </span>
        )}
      </Link>
    );
  }

  return (
    <Link to={to} className={`brand ${className}`} onClick={onClick}>
      {logoImg}
      {showText && (
        <div className="brand-text">
          <div className="t1">TRISHUL</div>
          <div className="t2">Tours &amp; Travels</div>
        </div>
      )}
    </Link>
  );
}
